import Model, {
  attr,
  belongsTo,
  hasMany,
  type SyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type CompanyModel from './company';

export default class UserModel extends Model {
  declare [Type]: 'user';
  @attr()
  declare email: string;
  @attr()
  declare name?: string;
  @attr()
  declare password?: string; // nur für admin?
  @attr()
  declare role: string; // nur für admin?
  @belongsTo('company', { async: false, inverse: 'users' })
  declare company: CompanyModel;
  @attr()
  declare created_at: string;
  @attr()
  declare updated_at: string;
}
